(function () {
  if (window.__blazeMiniCartCloseV3) return;
  window.__blazeMiniCartCloseV3 = true;

  function closeDrawer() {
    document.querySelectorAll('.cart-container').forEach(function (el) {
      el.classList.remove('active_link');
    });
    document.querySelectorAll('.dropdown_link.active_link, .mini_cart.active_link').forEach(function (el) {
      el.classList.remove('active_link');
    });
    document.body.classList.remove('blocked-scroll');
    document.body.classList.remove('is-active');
  }

  function onCartPayload(cart) {
    if (!cart) return;
    var count = Number(cart.item_count);
    if (count !== 0) return;
    closeDrawer();
  }

  if (window.jQuery) {
    window.jQuery(document).on('ajaxSuccess.blazeMiniCartCloseV3', function (_e, xhr, settings) {
      try {
        var url = settings && settings.url ? String(settings.url) : '';
        if (url.indexOf('/cart/change') === -1 && url.indexOf('/cart/update') === -1 && url.indexOf('/cart/clear') === -1) {
          return;
        }
        var data = xhr.responseJSON;
        if (!data) {
          try { data = JSON.parse(xhr.responseText); } catch (err) { return; }
        }
        onCartPayload(data);
      } catch (err2) {}
    });
  }
})();
